import MapObject from '@/models/MapObject'

class MapPin extends MapObject {
    object_name = 'MapPin'
}

export default MapPin
